export default {
  methods: {
    imagePath(path) {
      return image_path(path)
    }
  }
}
